import React from 'react';
import Logo from './Logo';

const DetailPromo = ({ onBack, activeBottomTab, setActiveBottomTab, selectedPromo, fromMemberArea }) => {
  if (!selectedPromo) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <button 
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <div className="flex items-center space-x-2">
                <Logo size="small" showText={false} />
                <span className="font-bold text-primary text-lg">Detail</span>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-32 bg-gray-50">
          {/* Hero Image */}
          <section className="relative">
            <div className="relative h-64 overflow-hidden">
              <img 
                src={selectedPromo.image} 
                alt={selectedPromo.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/30"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center justify-between mb-2">
                  <span className={`text-xs ${selectedPromo.badgeColor} font-semibold px-3 py-1 rounded-full`}>
                    {selectedPromo.badge}
                  </span>
                  <span className="bg-black/50 text-white text-xs font-medium px-2 py-1 rounded">
                    {selectedPromo.category}
                  </span>
                </div>
                <h1 className="text-white font-bold text-xl mb-1">{selectedPromo.title}</h1>
                <p className="text-gray-200 text-sm">{selectedPromo.date}</p>
              </div>
            </div>
          </section>

          {/* Content */}
          <section className="px-4 pt-6">
            <div className="bg-white rounded-2xl shadow-lg p-6">
              {/* Meta Info */}
              <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
                <div>
                  <p className="text-gray-600 text-sm">Dipublikasikan</p>
                  <p className="text-primary font-semibold">{selectedPromo.date}</p>
                </div>
                {selectedPromo.validUntil && (
                  <div className="text-right">
                    <p className="text-gray-600 text-sm">Berlaku hingga</p>
                    <p className="text-orange-500 font-semibold">{selectedPromo.validUntil}</p>
                  </div>
                )}
              </div>

              {/* Description */}
              <div className="mb-6">
                <h3 className="text-primary font-bold text-lg mb-3">Deskripsi</h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4">{selectedPromo.description}</p>
              </div>

              {/* Full Content */}
              <div className="mb-6">
                <h3 className="text-primary font-bold text-lg mb-3">Detail Lengkap</h3>
                <div className="text-gray-700 text-sm leading-relaxed space-y-4">
                  <p>{selectedPromo.content}</p>
                  
                  {selectedPromo.category === 'Promo' && (
                    <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                      <h4 className="text-red-700 font-bold text-sm mb-2">📢 Syarat dan Ketentuan Promo:</h4>
                      <ul className="text-red-600 text-xs space-y-1">
                        <li>• Promo berlaku untuk pembelian minimal Rp 5.000.000</li>
                        <li>• Tidak dapat digabung dengan promo lainnya</li>
                        <li>• Berlaku untuk stok terbatas</li>
                        <li>• Keputusan PAK MoO adalah mutlak</li>
                      </ul>
                    </div>
                  )}

                  {selectedPromo.category === 'Program' && (
                    <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                      <h4 className="text-green-700 font-bold text-sm mb-2">💡 Cara Bergabung:</h4>
                      <ul className="text-green-600 text-xs space-y-1">
                        <li>• Kunjungi kantor PAK MoO terdekat</li>
                        <li>• Isi formulir pendaftaran</li>
                        <li>• Melakukan pembayaran sesuai ketentuan</li>
                        <li>• Menunggu konfirmasi dari tim PAK MoO</li>
                      </ul>
                    </div>
                  )}

                  {selectedPromo.category === 'Berita' && (
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                      <h4 className="text-blue-700 font-bold text-sm mb-2">📈 Keuntungan Investasi:</h4>
                      <ul className="text-blue-600 text-xs space-y-1">
                        <li>• Return on Investment hingga 18% per tahun</li>
                        <li>• Manajemen ternak profesional</li>
                        <li>• Laporan perkembangan berkala</li>
                        <li>• Asuransi ternak terlindungi</li>
                      </ul>
                    </div>
                  )}

                  {selectedPromo.category === 'Layanan' && (
                    <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                      <h4 className="text-purple-700 font-bold text-sm mb-2">🎯 Layanan yang Disediakan:</h4>
                      <ul className="text-purple-600 text-xs space-y-1">
                        <li>• Konsultasi pemilihan hewan berkualitas</li>
                        <li>• Panduan perawatan hewan qurban</li>
                        <li>• Monitoring kesehatan hewan</li>
                        <li>• Dukungan teknis 24/7</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              {/* Contact Info */}
              <div className="bg-gray-50 rounded-xl p-4 mb-6">
                <h4 className="text-primary font-bold text-sm mb-3">📞 Butuh Bantuan?</h4>
                <p className="text-gray-600 text-xs mb-3">Tim customer service PAK MoO siap membantu Anda 24/7</p>
                <div className="flex space-x-3">
                  <button className="flex-1 bg-green-500 text-white text-xs font-semibold py-2 px-3 rounded-lg flex items-center justify-center space-x-1">
                    <i className="fa-brands fa-whatsapp"></i>
                    <span>WhatsApp</span>
                  </button>
                  <button className="flex-1 bg-blue-500 text-white text-xs font-semibold py-2 px-3 rounded-lg flex items-center justify-center space-x-1">
                    <i className="fa-solid fa-phone"></i>
                    <span>Telepon</span>
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Action Button */}
          <section className="px-4 mt-6">
            {selectedPromo.category === 'Promo' ? (
              <button className="w-full bg-accent text-primary font-bold py-4 px-6 rounded-2xl shadow-lg hover:bg-accent/90 transition-colors">
                <i className="fa-solid fa-tag mr-2"></i>
                Ambil Promo Sekarang
              </button>
            ) : selectedPromo.category === 'Program' ? (
              <button className="w-full bg-secondary text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:bg-secondary/90 transition-colors">
                <i className="fa-solid fa-piggy-bank mr-2"></i>
                Daftar Program Sekarang
              </button>
            ) : (
              <button className="w-full bg-primary text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:bg-primary/90 transition-colors">
                <i className="fa-solid fa-info-circle mr-2"></i>
                Hubungi Kami
              </button>
            )}
          </section>
          
          {/* Extra spacing for bottom navigation */}
          <div className="h-8"></div>
        </main>

        {/* Bottom Navigation */}
        <footer className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white pt-2">
          <div className="bg-primary mx-4 mb-4 rounded-2xl shadow-lg">
            <div className="flex justify-around items-center h-20 text-white">
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'home' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('home');
                  if (fromMemberArea) {
                    onBack(); // Kembali ke member area jika dari member area
                  } else {
                    onBack(); // Default behavior
                  }
                }}
              >
                <i className="fa-solid fa-house text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Beranda</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'savings' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('savings');
                  if (fromMemberArea) {
                    onBack(); // Kembali ke member area jika dari member area
                  } else {
                    onBack(); // Default behavior
                  }
                }}
              >
                <i className="fa-solid fa-piggy-bank text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Tabungan</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'products' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => setActiveBottomTab('products')}
              >
                <i className="fa-solid fa-box-archive text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Produk</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'investment' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('investment');
                  if (fromMemberArea) {
                    onBack(); // Kembali ke member area jika dari member area
                  } else {
                    onBack(); // Default behavior
                  }
                }}
              >
                <i className="fa-solid fa-arrow-trend-up text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Investasi</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'account' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('account');
                  if (fromMemberArea) {
                    onBack(); // Kembali ke member area jika dari member area
                  } else {
                    onBack(); // Default behavior
                  }
                }}
              >
                <i className="fa-solid fa-user-circle text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Akun</span>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DetailPromo;
